// Text-free article artwork; title-bearing covers remain available for social sharing.
export const editorialArtwork = new Set([
  "7-dax-measure-tests-before-migrating-to-sigma",
  "8-tests-for-choosing-a-sigma-migration-pilot",
  "10-checks-before-a-sigma-migration-cutover",
  "7-tableau-interactions-to-review-before-moving-to-sigma",
  "9-questions-to-ask-a-sigma-migration-consultant",
  "which-dashboards-to-migrate-consolidate-or-retire",
  "power-bi-tableau-to-sigma-migration-cost",
  "how-to-plan-a-power-bi-to-sigma-migration",
  "what-should-a-sigma-migration-assessment-include",
  "how-to-plan-a-tableau-to-sigma-migration",
  "how-long-does-a-sigma-migration-take",
  "how-to-validate-a-sigma-migration",
  "connect-excel-to-snowflake-with-private-key",
  "connect-excel-to-snowflake-with-private-key-mac"
]);
